export default __webpack_public_path__ + "static/media/Z3.3a130bf4.svg";